export enum AppBarTypes {
  Default = "Default",
  Central = "Central",
  Bold = "Bold",
}
